'use client';

import { Button } from '@shared/components/shadcn';
import { twMerge } from '@shared/themes';
import Link from 'next/link';
import { createPortal } from 'react-dom';
import { JackpotLabel } from '../../../../../lotteries/JackpotLabel/JackpotLabel';
import type { NextDrawStickyProps } from '../../types';

function NextDrawSticky({ className, lotteryName, jackpotText, jackpot, betUrl, placeBetText }: NextDrawStickyProps) {
  const lottery = lotteryName.toLowerCase();
  const classes = twMerge(
    `isolate fixed bottom-0 left-0 right-0 m-0! z-50 flex items-center justify-between gap-4 px-5 py-4 w-full bg-${lottery} text-foreground-${lottery} rounded-t-lg shadow-top-m`,
    className
  );

  return createPortal(
    <div className={classes} data-testid="next-draw-sticky" data-track-container="Actions">
      <div className="flex flex-col">
        <p className="paragraph-s">{jackpotText}</p>
        <JackpotLabel jackpotLabelSize="slim" namespace={`lotteries.${lotteryName}`} jackpot={jackpot} />
      </div>
      <Button asChild variant="primary" size="m" data-track-name="Place Bet">
        <Link href={betUrl}>{placeBetText}</Link>
      </Button>
    </div>,
    document.body
  );
}

export { NextDrawSticky };
